import { ChartData } from "chart.js";
import { useMemo } from "react";
import { CursorData, ViewTagsMap } from "../models/TrendingModels";

interface Props {
	cursorData: CursorData;
	viewTagsMap: ViewTagsMap;
	chartData: ChartData;
}

interface TagsDataTable {
	[tagName: string]: {
		y1: number;
		y2: number;
		y2y1: number;
		pmin: {
			x: number | Date;
			y: number;
		};
		pmax: {
			x: number | Date;
			y: number;
		};
	};
}

export const useTagsDataTable = ({
	cursorData,
	viewTagsMap,
	chartData,
}: Props): TagsDataTable => {
	return useMemo(() => {
		const dataTable: TagsDataTable = {};

		if (cursorData) {
			for (const viewTagEntry in viewTagsMap) {
				const tag = viewTagsMap[viewTagEntry].viewTag;

				const datasetForTag =
					chartData.datasets.find((ds: any) => {
						return ds.tagId === tag?.TagId;
					})?.data || [];

				let p1 = { x: new Date("1900-01-01"), y: 0 };
				let p1idx = 0;
				let p2idx = 0;
				let p2 = { x: new Date("1900-01-01"), y: 0 };
				let p1Found = false;

				let pmin = { x: 0, y: Number.POSITIVE_INFINITY };
				let pmax = { x: 0, y: Number.NEGATIVE_INFINITY };
				for (let idx = 0; idx < datasetForTag.length; idx++) {
					const curr = datasetForTag[idx];
					const currentVal = (curr! as any).x;

					if (!p1Found) {
						if (currentVal < cursorData.x1) {
							p1 = curr as any;
							p1idx = idx;
							p2idx = idx;
							p2 = JSON.parse(JSON.stringify(p1));
							pmin = JSON.parse(JSON.stringify(p1));
							pmax = JSON.parse(JSON.stringify(p1));
							continue;
						} else {
							p1Found = true;
						}
					} else {
						if (currentVal < cursorData.x2) {
							p2 = curr as any;
							p2idx = idx;

							if (pmin["y"] > (curr! as any)["y"]) {
								pmin = JSON.parse(JSON.stringify(curr));
							}

							if (pmax["y"] < (curr! as any)["y"]) {
								pmax = JSON.parse(JSON.stringify(curr));
							}
						} else {
							break;
						}
					}
				}

				dataTable[tag?.TagName] = {
					y1: p1.y,
					y2: p2.y,
					y2y1: Number(p2.y) - Number(p1.y),
					pmin,
					pmax,
				};
			}
		}

		return dataTable;
	}, [viewTagsMap, chartData, cursorData]);
};
